<template>
  <v-checkbox
    ref="checkbox"
    class="edn-checkbox"
    :off-icon="getIcon"
    v-model="Value"
    v-bind="$attrs"
    :color="$vuetify.theme.currentTheme.primary"
    :rules="rules"
    v-on="$listeners"
  >
    <template v-if="$attrs.tooltip" v-slot:append>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-icon size="16" v-on="on" style="cursor: pointer">mdi mdi-information</v-icon>
        </template>
        {{ $attrs.tooltip }}
      </v-tooltip>
    </template>
    <template v-slot:label> 
      <span :style="getLabelStyles">{{ $attrs.label }}</span>
      <span v-if="$attrs.required" class="red--text">*</span> 
    </template>
  </v-checkbox>
</template>

<script>
import { ednRequired } from './mixins/ednRequired'
import { ednValue } from './mixins/ednValue'

export default {
  inheritAttrs: false,
  mixins: [ednRequired, ednValue],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    labelStyles: {
      type: Object,
      default: () => {},
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    /** CSS styles for the label */
    getLabelStyles: function(){
      return this.labelStyles
    },
    getIcon:function() {
      return this.readonly ? "mdi-checkbox-blank" : "mdi-checkbox-blank-outline"
    }
  },
}
</script>
<style>
.edn-checkbox .v-input__append-outer {
  margin-bottom: 3px;
  margin-top: 3px;
}
</style>
